<div class="tags-modal">

  <!-- Header -->
  <h2 class="title">{{ 'tags' | translate }}</h2>
  <!-- Add Tag Form -->
  <aero-form [submitButtonLabel]="existingTag ? ('button_update' | translate) : ('button_add' | translate)"
             [showCancelButton]="true"
             [showSubmitButton]="true"
             (onCancel)="closePopUp()"
             (onSubmit)="addTag($event)">
    <div class="row">
      <aero-input
        id="tagName"
        name="tagName"
        label="{{ 'tags.dialog.tagName' | transloco }}"
        type="text"
        [(ngModel)]="tag.name"
        pattern=".*\S.*"
        [maxlength]="25"
        [required]="true"
        errorMessage="{{ 'tags.dialog.nameRequired' | transloco }}"></aero-input>
    </div>

    <div class="row">
      <aero-textarea name="tagDescription" label="{{ 'tags.dialog.tagDescription' | transloco }}" [(ngModel)]="tag.description"></aero-textarea>
    </div>

    <div class="form-row two-columns">
      <aero-input
        name="color"
        type="color"
        label="{{ 'tags.dialog.color' | transloco }}"
        [required]="true"
        [(ngModel)]="tag.colorCode"
        errorMessage="{{ 'tags.dialog.colorRequired' | transloco }}">
      </aero-input>

<!--      <aero-input-number-->
<!--        name="expectedUses"-->
<!--        id="expectedUses"-->
<!--        type="number"-->
<!--        label="Expected Uses"-->
<!--        [min]="1"-->
<!--        [required]="true"-->
<!--        [(ngModel)]="tag.expectedUses"-->
<!--        errorMessage="Expected Uses is required">-->
<!--      </aero-input-number>-->

      <aero-multiselect
        *ngIf="isOrgTag"
        name="grades"
        label="{{ 'organization_dashboard_bottom_grade_tab' | translate }}"
        id="gradeMultiSelect"
        placeholder="{{ 'copyTemplate.gradePlaceholder' | transloco }}"
        [options]="gradeOptions"
        [(value)]="tag.grades"
        [(ngModel)]="tag.grades"
        optionLabel="name"
        optionValue="code"
        data-key="id">
      </aero-multiselect>
    </div>

<!--    When we need expected uses field back then delete grade field from above and uncomment below one.-->
<!--    <div class="row">-->
<!--      <aero-multiselect-->
<!--        name="grades"-->
<!--        label="Grades"-->
<!--        id="gradeMultiSelect"-->
<!--        placeholder="{{ 'copyTemplate.gradePlaceholder' | transloco }}"-->
<!--        [options]="gradeOptions"-->
<!--        [(value)]="tag.grades"-->
<!--        [(ngModel)]="tag.grades"-->
<!--        optionLabel="name"-->
<!--        optionValue="code"-->
<!--        data-key="id">-->
<!--      </aero-multiselect>-->
<!--    </div>-->
  </aero-form>
</div>
